import React, { useState } from "react";
import CustomModel from "./customModel";
import { category } from "../../constants/category";
import Icon from "./icon";

const inputClass =
  "w-full px-4 py-3 bg-gray-50 rounded-xl border border-purple-200 outline-none text-sm text-gray-900 focus:border-primary";

const toLocalYMD = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

function FilterPopup(props) {
  const { open, onClose, setDate, date, type, setType } = props;

  // Pending state — only committed to parent on Apply/Reset so all three
  // state updates (date, type, showFilter=false) happen in ONE event handler,
  // letting React batch them into a single render and avoiding the stale-list
  // flash that occurred when setDate fired live on each date change.
  const [pendingDate, setPendingDate] = useState(toLocalYMD(date));
  const [pendingType, setPendingType] = useState(type);

  const handleApply = () => {
    setDate(new Date(pendingDate + "T00:00:00"));
    setType(pendingType);
    onClose();
  };

  const handleReset = () => {
    setDate(new Date());
    setType("all");
    onClose();
  };

  return (
    <CustomModel
      showCloseIcon={true}
      open={open}
      onClose={onClose}
      className="bg-white rounded-3xl"
    >
      <div className="py-2">
        <h2 className="text-lg font-semibold text-gray-900 text-center mb-4">
          Filter
        </h2>
        <div className="flex flex-col gap-3">
          <div>
            <label className="text-xs font-medium text-gray-500 mb-1 block">
              Date
            </label>
            <input
              type="date"
              className={inputClass}
              onChange={(e) => setPendingDate(e.target.value)}
              value={pendingDate}
            />
          </div>
          <div>
            <label className="text-xs font-medium text-gray-500 mb-2 block">
              Category
            </label>
            <div className="flex items-center gap-2 flex-wrap">
              {category.map((cate) => (
                <label
                  key={cate.value}
                  className={`flex flex-col items-center px-3 py-2 rounded-xl cursor-pointer ${
                    pendingType === cate.value
                      ? "bg-primary-bg border border-primary"
                      : "bg-gray-50 border border-transparent"
                  }`}
                >
                  <input
                    type="radio"
                    name="category"
                    value={cate.value}
                    checked={pendingType === cate.value}
                    onChange={() => setPendingType(cate.value)}
                    className="sr-only"
                  />
                  <Icon
                    className={
                      pendingType === cate.value ? "text-primary" : "text-gray-400"
                    }
                    icon={cate.icon}
                  />
                  <span
                    className={`text-xs mt-1 ${
                      pendingType === cate.value
                        ? "text-primary font-medium"
                        : "text-gray-500"
                    }`}
                  >
                    {cate.name}
                  </span>
                </label>
              ))}
              <label
                className={`flex flex-col items-center px-3 py-2 rounded-xl cursor-pointer ${
                  pendingType === "all"
                    ? "bg-primary-bg border border-primary"
                    : "bg-gray-50 border border-transparent"
                }`}
              >
                <input
                  type="radio"
                  name="category"
                  value="all"
                  checked={pendingType === "all"}
                  onChange={() => setPendingType("all")}
                  className="sr-only"
                />
                <span className="text-xs text-gray-500">All</span>
              </label>
            </div>
          </div>
        </div>
        <div className="flex gap-3 mt-5">
          <button
            onClick={handleApply}
            className="flex-1 py-3 bg-primary hover:bg-primary-light rounded-xl text-white font-semibold text-sm"
          >
            Apply
          </button>
          <button
            onClick={handleReset}
            className="flex-1 py-3 bg-white border border-gray-200 rounded-xl text-gray-700 font-semibold text-sm hover:bg-gray-50"
          >
            Reset
          </button>
        </div>
      </div>
    </CustomModel>
  );
}

export default FilterPopup;
